/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

import DetailEpsonHistoryImg from './DetailsEpsonCRHistory.png';
import DetailEpsonProjectorOneImg from './DetailsEpsonCRProjector1.png';
import DetailEpsonProjectorTwoImg from './DetailsEpsonCRProjector2.png';
import DetailEpsonProjectorThreeImg from './DetailsEpsonCRProjector3.png';
import DetailEpsonProjectorFourImg from './DetailsEpsonCRProjector4.png';
import DetailEpsonPrinterOneImg from './DetailsEpsonCRPrinter1.png';
import DetailEpsonPrinterTwoImg from './DetailsEpsonCRPrinter2.png';
import DetailEpsonPrinterThreeImg from './DetailsEpsonCRPrinter3.png';
import DetailEpsonPrinterFourImg from './DetailsEpsonCRPrinter4.png';
import DetailEpsonSmartGlassOneImg from './DetailsEpsonCRSmartGlass1.png';
import DetailEpsonSmartGlassTwoImg from './DetailsEpsonCRSmartGlass2.png';
import DetailEpsonSmartGlassThreeImg from './DetailsEpsonCRSmartGlass3.png';

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #363a3c;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const SubSection = styled.div`
  margin-bottom: 50px;
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 16px 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HighlightText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 20px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const CssHeaderText100 = css`
  font-weight: 100;
`;
const CssHeaderText300 = css`
  font-weight: 300;
`;
const CssHeaderText400 = css`
  font-weight: 400;
`;

const DivFlexboxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const DivFlexItem = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px;
  flex-direction: column;
`;
const DivFlexboxNoWrap = styled.div`
  display: flex;
  justify-content: center;
`;
const DivFlexItemNoWrap = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  padding-top: 20px;
`;
const ImgFlexItemNoWrap = styled.img`
  width: 100%;
`;

const SpanAbsoluteBold = styled.span`
  position: absolute;
  font-weight: 700;
`;
const DivIndent20 = styled.div`
  margin-left: 20px;
`;

class DetailsEpsonCR extends Component {
  render() {
    return (
      <div className="DetailsEpsonCR">

        <Section className="section">
          <ContainerFluid className="container-fluid">

            <SubSection className="Intro">
              <p className="header-text-300" css={CssHeaderText300}>봄시스템즈는 Epson사의 CR(Corporate Reseller)로서 엡손코리아의 다양한 제품들에 대해서 가장 경쟁력 있는 제안을 제시하고 있습니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>고객의 비즈니스 전략과 환경을 분석, 이에 최적화된 솔루션을 제안함으로써, 생산성은 향상하고 비용은 절감할 수 있는 대안을 도출하고자 노력하고 있습니다.</p>

              <DivFlexboxNoWrap className="DivFlexboxNoWrap">
                <DivFlexItemNoWrap><ImgFlexItemNoWrap src={DetailEpsonHistoryImg}/></DivFlexItemNoWrap>
              </DivFlexboxNoWrap>
            </SubSection>

            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span className="CssHeaderText400">프로젝터</span>
              </HighlightText>

              <p className="header-text-300" css={CssHeaderText300}>15년 연속 세계시장 점유율 1위(2019년, 퓨처소스 컨설팅)의 엡손 프로젝터!</p>
              <p className="header-text-300" css={CssHeaderText300}>Seiko-Epson사는 3LCD 기술을 바탕으로한 대형강당용 고광량 프로젝트부터 교육용, 비즈니스용, 가정용에 이르기까지 다양하고 풍부한 제안하고 있습니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>봄시스템즈는 고객사의 니즈와 환경에 최적인 Epson사의 프로젝터 제품을 가장 경쟁력 있는 가격으로 제안하고자 합니다.</p>

              <DivFlexboxWrap className="DivFlexboxWrap">
                <DivFlexItem><img src={DetailEpsonProjectorOneImg}/><div>EB-L12000Q</div></DivFlexItem>
                <DivFlexItem><img src={DetailEpsonProjectorTwoImg}/><div>EB-G7900U</div></DivFlexItem>
                <DivFlexItem><img src={DetailEpsonProjectorThreeImg}/><div>EV-100</div></DivFlexItem>
                <DivFlexItem><img src={DetailEpsonProjectorFourImg}/><div>EB-685Wi</div></DivFlexItem>
              </DivFlexboxWrap>
            </SubSection>

            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span className="CssHeaderText400">프린터</span>
              </HighlightText>

              <p className="header-text-300" css={CssHeaderText300}>Epson의 축적된 잉크젯 기술로 탁월한 품질, 높은 생산성, 친환경을 매우 경제적인 유지비용으로 즐길 수 있습니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>SOHO를 위한 정품무한 잉크젯 프린터, 1분에 100매출력의 고속 비즈니스 잉크젯, 산업용 라벨프린터, 사이니지 제작을 위한 대형 고품질 프린터에 이르기까지 각 산업별 고객군의 니즈에 최적화된 제품을 제안하고 있습니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>봄시스템즈는 고객사의 니즈와 환경에 최적인 Epson사의 프린터 제품을 가장 경쟁력 있는 가격으로 제안하고자 합니다.</p>

              <DivFlexboxWrap className="DivFlexboxWrap">
                <DivFlexItem><img src={DetailEpsonPrinterOneImg}/><div>WF-C20590</div></DivFlexItem>
                <DivFlexItem><img src={DetailEpsonPrinterTwoImg}/><div>L6190</div></DivFlexItem>
                <DivFlexItem><img src={DetailEpsonPrinterThreeImg}/><div>TM-C7500</div></DivFlexItem>
                <DivFlexItem><img src={DetailEpsonPrinterFourImg}/><div>SC-S80610</div></DivFlexItem>
              </DivFlexboxWrap>
            </SubSection>

            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span className="CssHeaderText400">스마트글라스스</span>
             </HighlightText>

              <p className="header-text-300" css={CssHeaderText300}>눈앞에 펼쳐지는 환상적인 화면, 작은 디테일이 큰차이를 만듭니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>Epson은 2011년부터 꾸준히 스마트글라스 제품을 출시하면서 시장을 선도하고 있습니다. Preformed-surface Lightguide 기술을 바탕으로한 선명한 화질, See-through OTG로 구현된 폭넓은 적용성은 소비자에게는 새로운 컨텐츠 소비의 경험을 제공할 뿐 아니라, 산업현장이나 드론 촬영 등 전문적인 영역에서도 부가가치를 제공합니다.</p>

              <DivFlexboxWrap className="DivFlexboxWrap">
                <DivFlexItem><img src={DetailEpsonSmartGlassOneImg}/></DivFlexItem>
                <DivFlexItem><img src={DetailEpsonSmartGlassTwoImg}/></DivFlexItem>
                <DivFlexItem><img src={DetailEpsonSmartGlassThreeImg}/></DivFlexItem>
              </DivFlexboxWrap>
            </SubSection>

          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default DetailsEpsonCR;
